import mapStyle from './../json/map-style.json'

window.addEventListener('load', async function() {

  let mapElement = document.getElementById("locations_map");
  if ( ! mapElement ) return;

  // From https://stackoverflow.com/a/16124729
  google.maps.Polygon.prototype.customGetBounds=function(){
    var bounds = new google.maps.LatLngBounds()
    this.getPath().forEach(function(element,index){bounds.extend(element)})
    return bounds
  }

  const departements = mapElement.dataset.departements.split(",");
  const data = await import('./../json/departements-version-simplifiee.geojson');

  function initMap() {
    const dealerPolygons = {}
    const bounds = new google.maps.LatLngBounds();

    // Store department polygons
    data.features.forEach((departement) => {

      // Map different kind of data
      const departementGroups = departement.geometry.coordinates.length == 1 ? [departement.geometry.coordinates] : departement.geometry.coordinates;

      const departementPolygons = [];
      departementGroups.forEach((departementGroup) => {

        // Map different kind of data
        departementGroup = departementGroup[0].length > 2 ? departementGroup[0] : departementGroup;

        const departementPolygon = [];
        departementGroup.forEach((coordinate) => {

          if (departements.includes(departement.properties.code) ) {
            // Store point with all Points
            const currentLatLngPoint = new google.maps.LatLng(coordinate[1], coordinate[0]);
            bounds.extend(currentLatLngPoint);
          }

          // Store point into polygon
          departementPolygon.push({lat: coordinate[1], lng: coordinate[0]});
        });

        // Store polygon into department polygons
        departementPolygons.push(departementPolygon);
      });

      // Store department polygons into dealer polygons
      dealerPolygons[departement.properties.code] = departementPolygons
    });

    // Create map
    const map = new google.maps.Map(mapElement, {
      disableDefaultUI: true,
      draggable: false,
      gestureHandling: "none",
      zoomControl: false,
      styles: mapStyle
    });

    // Display polygons on map
    for (const key in dealerPolygons) {
      if (Object.hasOwnProperty.call(dealerPolygons, key)) {
        const isCurrent = departements.includes(key)
        const departementPolygons = dealerPolygons[key];

        const polygon = new google.maps.Polygon({
          paths: departementPolygons,
          strokeColor: isCurrent ? "#ffffff" : "#a2a4a6",
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: isCurrent ? "#d9953b" : "#ffffff",
          fillOpacity: 1,
          clickable: false
        })

        polygon.setMap(map);

        if (isCurrent) {
          new google.maps.Marker({
            position: polygon.customGetBounds().getCenter(),
            icon: ' ',
            label: {
              color: '#ffffff',
              fontFamily: 'Nexa',
              fontWeight: 'normal',
              fontSize: '16px',
              text: key
            },
          }).setMap(map)
        }
      }
    }

    // Fit map to bounds
    map.fitBounds(bounds);
  }

  initMap();
});